/* eslint-disable no-unused-vars */
export enum QuoteType {
  OneWay = "One-Way",
  TwoWay = "Two-Way",
  Mid = "Mid",
}
